import { render, staticRenderFns } from "./systemRoles.vue?vue&type=template&id=00f1ee43&scoped=true"
import script from "./systemRoles.vue?vue&type=script&lang=js"
export * from "./systemRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f1ee43",
  null
  
)

export default component.exports